import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/scan-btn.png'


const _withScopeId = n => (_pushScopeId("data-v-11c5b956"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-con" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"30%","height":"auto"}
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"padding-top":"1rem"},
  class: "desc"
}, "扫描核销码或者输入SN码核销", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_field, {
        modelValue: _ctx.orderId,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.orderId) = $event)),
        center: "",
        clearable: "",
        placeholder: "输入SN码核销"
      }, {
        button: _withCtx(() => [
          _createElementVNode("div", {
            style: {"color":"#d8c14f"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hx_click && _ctx.hx_click(...args)))
          }, "验证")
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", {
      class: "scan-con",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.scan_click && _ctx.scan_click(...args)))
    }, _hoisted_4)
  ], 64))
}